import CircularProgress from '@mui/material/CircularProgress';
import Center from './Center';
import { Typography } from '@mui/material';

export interface LoaderProps {
  message?: string;
  padding?: number;
}

function Loader({ message, padding }: LoaderProps) {
  return (
    <Center p={padding ?? 0}>
      <CircularProgress color="primary" sx={{ marginTop: 2 }} />
      {message && (
        <Typography variant="h6" color={(theme) => theme.palette.grey['500']} mt={12}>
          {message}
        </Typography>
      )}
    </Center>
  );
}

export default Loader;
